/**
 * Кастомный toast-сервис без инлайн-стилей (CSP-совместимый).
 * Полная замена react-hot-toast API: toast.success(), toast.error(), toast.info(), toast.warning()
 * При появлении тоста блокирует весь контент на экране до нажатия кнопки закрытия.
 */
import './toast.css';

type ToastType = 'success' | 'error' | 'info' | 'warning';

const ICONS: Record<ToastType, string> = {
  success: '✅',
  error: '❌',
  info: 'ℹ️',
  warning: '⚠️',
};

let container: HTMLDivElement | null = null;
let overlay: HTMLDivElement | null = null;
let activeCount = 0;

function getContainer(): HTMLDivElement {
  if (!container || !document.body.contains(container)) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }
  return container;
}

function showOverlay(): void {
  if (!overlay || !document.body.contains(overlay)) {
    overlay = document.createElement('div');
    overlay.className = 'toast-overlay';
    document.body.appendChild(overlay);
  }
}

function hideOverlayIfEmpty(): void {
  if (activeCount <= 0 && overlay && document.body.contains(overlay)) {
    overlay.remove();
    overlay = null;
  }
}

function show(type: ToastType, message: string): string {
  const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const toast = document.createElement('div');
  toast.id = id;
  toast.className = `toast toast--${type}`;
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'polite');

  const icon = document.createElement('span');
  icon.className = 'toast__icon';
  icon.textContent = ICONS[type];

  const msg = document.createElement('span');
  msg.className = 'toast__message';
  msg.textContent = message;

  const closeBtn = document.createElement('button');
  closeBtn.className = 'toast__close';
  closeBtn.setAttribute('aria-label', 'Закрыть');
  closeBtn.textContent = '×';
  closeBtn.addEventListener('click', () => remove(id));

  toast.appendChild(icon);
  toast.appendChild(msg);
  toast.appendChild(closeBtn);
  getContainer().appendChild(toast);

  activeCount++;
  showOverlay();

  return id;
}

function remove(id: string): void {
  const el = document.getElementById(id);
  if (el) {
    el.remove();
    activeCount = Math.max(0, activeCount - 1);
    hideOverlayIfEmpty();
  }
}

function dismiss(id?: string): void {
  if (id) {
    remove(id);
  } else if (container) {
    container.innerHTML = '';
    activeCount = 0;
    hideOverlayIfEmpty();
  }
}

const toast = {
  success: (message: string) => show('success', message),
  error:   (message: string) => show('error',   message),
  info:    (message: string) => show('info',    message),
  warning: (message: string) => show('warning', message),
  dismiss,
};

export default toast;

